import { useContext } from 'react';

import { SynchronizedCrosshairContext } from '../contexts/SynchronizedCrosshair.context.js';

/**
 * @internal
 */
export const useSynchronizedCrosshair = () =>
  useContext(SynchronizedCrosshairContext);
